import { render, staticRenderFns } from "./Form06.vue?vue&type=template&id=9b141e90"
import script from "./Form06.vue?vue&type=script&lang=js"
export * from "./Form06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports